const OTHER_MODEL_OPTION = { value: "other", label: "Other", historical: false };

export function activeDeviceModelOptions(deviceModels = []) {
  const seen = new Set();
  const options = [];

  deviceModels.forEach((model) => {
    const name = typeof model?.name === "string" ? model.name.trim() : "";
    const normalized = name.toLowerCase();
    if (model?.is_active !== true || !name || normalized === "other" || seen.has(normalized)) return;
    seen.add(normalized);
    options.push({ value: name, label: name, historical: false });
  });

  return [...options, OTHER_MODEL_OPTION];
}

export function deviceModelOptionsWithHistory(
  deviceModels,
  historicalSelection,
  historicalLabel = ""
) {
  const options = activeDeviceModelOptions(deviceModels);
  const selection = typeof historicalSelection === "string" ? historicalSelection.trim() : "";
  if (!selection || options.some((option) => option.value === selection)) return options;

  return [
    {
      value: selection,
      label: (typeof historicalLabel === "string" && historicalLabel.trim()) || selection,
      historical: true,
    },
    ...options,
  ];
}

export function modelNameForSelection(options, selection) {
  return options.find((option) => option.value === selection)?.label || "";
}
